module.exports = __webpack_public_path__ + "static/media/close.e6368a8e.svg";